import { connect } from 'react-redux'
import ConnectedQAMenu from 'pages/qamenu/ConnectedQAMenu'
import { setQASections, setQAPickedSection, setQARootSections, setTiledMenuIsLoaded } from 'redux/actions'

const mapStateToProps = state => ({
  aol: state.aol.name,
  isTiledMenuLoaded: state.placeholders.isTiledMenuLoaded,
  sections: state.qa.sections,
  rootSections: state.qa.rootSections,
  pickedSection: state.qa.pickedSection,
  headerHeight: state.layout.headerHeight,
  isMobile: state.layout.deviceType.isMobile,
  pageParameters: state.page.configParameters
})

const mapDispatchToProps = dispatch => ({
  setQASections: qaSections => dispatch(setQASections(qaSections)),
  setTiledMenuIsLoaded: isLoaded => dispatch(setTiledMenuIsLoaded(isLoaded)),
  setQAPickedSection: (flavour, sections) => dispatch(setQAPickedSection(flavour, sections)),
  setQARootSections: (pickedSection) => dispatch(setQARootSections(pickedSection))
})

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedQAMenu)
